import type {
  ContractDetailRecord,
  ContractGenerationPreviewRecord,
  ContractTemplateCollectionRecord,
  ContractTemplateDetailRecord,
  ContractTemplateUpsertInput,
  GenerateContractFromTemplateInput,
  PreviewContractGenerationInput
} from '@shared/types';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listContractTemplates(): Promise<ContractTemplateCollectionRecord> {
  return getDesktopApi().contracts.listContractTemplates();
}

export async function getContractTemplateById(templateId: string): Promise<ContractTemplateDetailRecord | null> {
  return getDesktopApi().contracts.getContractTemplateById(templateId);
}

export async function saveContractTemplate(payload: ContractTemplateUpsertInput): Promise<ContractTemplateDetailRecord> {
  return getDesktopApi().contracts.saveContractTemplate(payload);
}

export async function previewContractGeneration(
  payload: PreviewContractGenerationInput
): Promise<ContractGenerationPreviewRecord> {
  return getDesktopApi().contracts.previewContractGeneration(payload);
}

export async function generateContractFromTemplate(
  payload: GenerateContractFromTemplateInput
): Promise<ContractDetailRecord> {
  return getDesktopApi().contracts.generateContractFromTemplate(payload);
}
